import { Grid, GridGap } from 'components/Grid'
import Heading from 'components/Heading'
import { List, ListItem } from 'components/List'
import Section from 'components/Section'
import { SectionType, Size } from 'components/Section/Section'
import * as React from 'react'
import { getCdnUrl } from '../../../data/api/cdn'
import { ContentProps } from '../../../data/entries/types'
import DisplayContent from '../../shared/content'

interface FoodLoversFlavourBoxProps {
  content?: ContentProps
  numberOfItemsLeft: number
  numberOfItemsRight: number
}

export const FoodLoversFlavourBox: React.FC<FoodLoversFlavourBoxProps> = ({
  content,
  numberOfItemsLeft,
  numberOfItemsRight,
}) => {
  const renderExplain = (
    leftOrRight: 'left' | 'right',
    numberOfItems: number,
  ) => {
    let length = numberOfItems
    if (content) {
      if (leftOrRight === 'left' && content.explainLeft) {
        length = content.explainLeft
      }
      if (leftOrRight === 'right' && content.explainRight) {
        length = content.explainRight
      }
    }
    const output = []
    for (let i = 1; i <= length; i++) {
      output.push(
        <ListItem dash key={i}>
          <DisplayContent contentKey={`explain-${leftOrRight}-text-${i}`}>
            {`explain-${leftOrRight}-text-${i}`}
          </DisplayContent>
        </ListItem>,
      )
    }
    return output
  }

  return (
    <Section
      type={SectionType.photo}
      size={Size.m}
      src={{
        blurMobile: true,
        src: getCdnUrl('foodlovers-full-section-bg-768.jpg'),
        src1024: getCdnUrl('foodlovers-full-section-bg-1024.jpg'),
        src1280: getCdnUrl('foodlovers-full-section-bg-1280.jpg'),
        src1600: getCdnUrl('foodlovers-full-section-bg-1600.jpg'),
        src1920: getCdnUrl('foodlovers-full-section-bg-1920.jpg'),
      }}
    >
      <Grid nrCols={[1, 2]} rowGap={[GridGap.m]} className={'grid-white-text'}>
        <div>
          <Heading level={4}>
            <DisplayContent contentKey="explain-left-heading">
              What we do for you
            </DisplayContent>
          </Heading>
          <List>{renderExplain('left', numberOfItemsLeft)}</List>
        </div>
        <div>
          <Heading level={4}>
            <DisplayContent contentKey="explain-right-heading">
              What you need to arrange yourself
            </DisplayContent>
          </Heading>
          <List>{renderExplain('right', numberOfItemsRight)}</List>
        </div>
      </Grid>
    </Section>
  )
}
